<template>
    <div>
        <Loading v-if="isLoading"/>
        <template v-else>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <ol class="breadcrumb">
                            <li><a :href="home_url"> HOME</a>
                            </li>
                            <li>
                                <router-link :to="{name: 'ArtifactsList'}">{{$t('archive')}}</router-link>
                            </li>
                            <li>
                                <a href="javascript:;" @click="resetFilter">{{$t('collection')}}</a>
                            </li>
                            <li v-if="selectedSites.length > 0">
                                {{selectedSitesBreadcrumb.join(',')}}
                            </li>
                            <li v-if="selectedAreas.length > 0">
                                {{selectedAreasBreadcrumb.join(',')}}
                            </li>
                            <li v-if="selectedTypes.length > 0">
                                {{selectedTypesBreadcrumb.join(',')}}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="container">
                    <div class="row">
                        <div class="col-12 content">
                            <h1>{{$t('search_by_location')}}</h1>
                            <dl class="search-result">
                                <dt>{{$t('result')}}：</dt>
                                <dd>{{this.total}} {{$t('item')}}</dd>
                            </dl>
                            <section class="area-search">
                                <h2><span>{{$t('narrow_down_by_conditions')}}</span></h2>
                                <dl class="area-search-dl">
                                    <dt>{{$t('search_by_area')}}</dt>
                                    <dd v-if="areas.length > 0">
                                        <ul>
                                            <li v-for="area in areas" :key="area.id">
                                                <a href="javascript:;" @click="addRemoveArea(area)" class="r-icon"
                                                   :class="selectedAreas.includes(area.id) ? 'active ' + area.slug : area.slug">{{area.name}}</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl class="remains-search-dl">
                                    <dt>{{$t('search_by_site')}}</dt>
                                    <dd v-if="sites.length > 0">
                                        <ul>
                                            <template v-for="site in sites" :key="site.id">
                                                <li><a href="javascript:;" @click="addRemoveSite(site)"
                                                       :class="selectedSites.includes(site.id) ? 'active ' + getAreasBySite(site) : getAreasBySite(site)">
                                                    {{ site.title }}
                                                </a>
                                                </li>
                                            </template>
                                        </ul>
                                    </dd>
                                </dl>
                                <dl class="type-search">
                                    <dt>{{$t('search_by_classification')}}</dt>
                                    <dd>
                                        <ul>
                                            <li v-for="type in assetTypes" :key="type.id">
                                                <a href="javascript:;" @click="addRemoveTypes(type)"
                                                   :class="selectedTypes.includes(type.id) ? 'active' : ''">{{type.name}}</a>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </section>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="content"><!--ここからコンテンツ-->
                                <section class="new-item">
                                    <h2><span>{{$t('search_results')}}</span></h2>
                                    <dl>
                                        <dd>
                                            <AssetList
                                                :key="infiniteId"
                                                :layout_type="'artifacts'"
                                                :per_page="30"
                                                @setTotal="setTotal"
                                                :show_pagination="true"
                                                :selectedAreas="selectedAreas"
                                                :selectedTypes="selectedTypes"
                                                :selectedSites="selectedSites"
                                            />
                                        </dd>
                                    </dl>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Loading from "../components/Loading";
import axios from "axios";
import AssetList from "../components/AssetList";

export default {
    name: "ArtifactList",
    components: {AssetList, Loading},
    props: {
        selectedArea: {
            type: Object,
            default: null
        },
        selectedSite: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isLoading: false,
            assets: [],
            areas: [],
            sites: [],
            lang: lang,
            selectedAreas: this.selectedArea !== null ? [this.selectedArea.id] : [],
            selectedAreasBreadcrumb: this.selectedArea !== null ? [this.selectedArea.name] : [],
            selectedSitesBreadcrumb: this.selectedSite !== null ? [this.selectedSite.title] : [],
            selectedTypesBreadcrumb: [],
            selectedSites: this.selectedSite !== null ? [this.selectedSite.id] : [],
            selectedTypes: [],
            home_url: home_url,
            type: null,
            total: 0,
            infiniteId: +new Date(),
            tag: null,
            assetTypes: []
        }
    },
    mounted() {
        window.history.scrollRestoration = "manual"
        window.scrollTo(0, 0)
    },
    created() {
        this.listAreas()
    },
    methods: {
        resetFilter() {
            this.selectedSites = []
            this.selectedSitesBreadcrumb = []
            this.selectedAreas = []
            this.selectedAreasBreadcrumb = []
            this.selectedTypes = []
            this.selectedTypesBreadcrumb = []
        },
        addRemoveArea(area) {
            // if (this.selectedSites.length > 0) {
            //     this.selectedSites = []
            //     this.selectedSitesBreadcrumb = []
            // }
            if (this.selectedAreas.includes(area.id)) {
                let index = this.selectedAreas.indexOf(area.id)
                if (index > -1) {
                    this.selectedAreas.splice(index, 1);
                    this.selectedAreasBreadcrumb.splice(index, 1);
                }
            } else {
                this.selectedAreas.push(area.id)
                this.selectedAreasBreadcrumb.push(area.name)
            }
            this.infiniteId++
        },
        addRemoveSite(site) {
            // if (this.selectedAreas.length > 0) {
            //     this.selectedAreas = []
            //     this.selectedAreasBreadcrumb = []
            // }
            if (this.selectedSites.includes(site.id)) {
                let index = this.selectedSites.indexOf(site.id)
                if (index > -1) {
                    this.selectedSites.splice(index, 1);
                }
            } else {
                this.selectedSites.push(site.id)
                this.selectedSitesBreadcrumb.push(site.title)

            }
            this.infiniteId++
        },
        addRemoveTypes(type) {
            if (this.selectedTypes.includes(type.id)) {
                let index = this.selectedTypes.indexOf(type.id)
                if (index > -1) {
                    this.selectedTypes.splice(index, 1);
                    this.selectedTypesBreadcrumb.splice(index, 1);
                }
            } else {
                this.selectedTypes.push(type.id)
                this.selectedTypesBreadcrumb.push(type.name)

            }
            this.infiniteId++
        },
        setTotal(total) {
            this.total = total
        },
        getAreasBySite(site) {
            if (site.area.parent !== null) {
                return site.area.parent_slug;
            } else {
                return site.area.slug
            }
        },
        listAreas() {
            this.isLoading = true
            let params = {
                lang: this.lang,
                type: 'site-area',
                slugs: 'jomon-archaeological-sites,hokkaido,aomori,iwate,akita'
            }
            const config = {
                params: params
            }
            axios.get('/api/terms', config)
                .then((res) => {
                    this.areas = res.data.data
                })
                .finally(() => {
                    this.getSites()
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        getSites() {
            const config = {
                params: {
                    lang: this.lang
                }
            }
            axios.get('/api/sites', config)
                .then((res) => {
                    this.sites = res.data
                })
                .finally(() => {
                    this.getAssetType()
                })
        },
        getAssetType() {
            let params = {
                lang: this.lang,
                type: 'asset-type'
            }
            const config = {
                params: params
            }
            axios.get('/api/terms', config)
                .then((res) => {
                    this.assetTypes = res.data.data.sort(function(item1, item2) {
                        return item1.order - item2.order;
                    })
                })
                .finally(() => {
                    this.isLoading = false
                })
                .catch((error) => {
                    console.log(error)
                })

        }
    }
}
</script>

<style scoped>

</style>
